<!--
* @description  参数1
* @fileName  clientLayout
* @author userName
* @date 2023-12-24 11:09:57
!-->
<template>
  <div id="clientLayout" class="clientLayout">
    <div class="common-layout">
      <ClientTop class="header"></ClientTop>
      <div class="body-content">
        <router-view />
      </div>
      <ClientBottom class="footer"></ClientBottom>
      <!-- <el-container>
          <el-header>
            <ClientTop></ClientTop>
          </el-header>
          <el-container>
            <el-main><router-view/></el-main>
          </el-container>
          <el-footer>
            <ClientBottom></ClientBottom>
          </el-footer>

        </el-container> -->
    </div>
  </div>
</template>

<script>
import ClientTop from './clientTop/index';
import ClientBottom from './clientBottom/index';
export default {
  props: {
    // 父辈向子辈传参
  },
  name: 'clientLayout',
  data() {
    return {};
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
    ClientTop,
    ClientBottom,
  },
  methods: {
    // 方法
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang="scss">
.clientLayout {
  //background: #f5f7fa;
  // position: absolute;
  // left: 0;
  // top: 0;
  // right: 0;
  // bottom: 0;
  width: 100%;
  min-width: 1200px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    height: 64px;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: left;
    //padding-left: 32px;
    background: rgba(255, 255, 255, 0.56);
    backdrop-filter: blur(4px);
    position: sticky;
    left: 0px;
    top: 0;
    width: 100%;
    z-index: 100;
  }
  .body-content {
    margin: 0px 0;
    min-height: 800px;
  }
  .footer {
    //position: fixed;
    left: 0px;
    width: 100%;
    bottom: 0px;
    z-index: 10;
  }
}
.el-header {
  height: 64px !important;
}
::v-deep .el-footer,
.el-main {
  height: auto;
  padding: 0;
}
</style>
